import React from 'react';

const headerImage = `${process.env.PUBLIC_URL}/images/jmheader.png`;

const experience = [
  {
    id: 'kami-of-albion',
    emoji: '🌸',
    title: 'Kami of Albion',
    link: 'https://kamiofalbion.com/',
  },
  {
    id: 'learn-russian-cases',
    emoji: '🪆',
    title: 'LearnRussianCases',
    link: 'https://learnrussiancases.com',
  },
  {
    id: 'piano-dash',
    emoji: '🎹',
    title: 'Piano Dash',
    link: 'https://pianodash.com/',
  },
  {
    id: 'ebbinghaus',
    emoji: '🧠',
    title: 'Ebbinghaus',
    link: 'https://ebbinghaus.app/',
  },
];

function Card({ children, className = '' }) {
  return (
    <section
      className={`w-full bg-backgroundSecondary border border-borderPrimary ${className}`}
    >
      {children}
    </section>
  );
}

function ExternalLink({ href, children }) {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      className="underline"
      href={href}
    >
      {children}
    </a>
  );
}

function ExperienceItem({ item }) {
  return (
    <div className="my-4 flex items-center min-[801px]:my-3">
      <span className="w-12 shrink-0 font-notoEmoji text-[12pt] leading-none">
        {item.emoji}
      </span>
      <div className="flex min-w-0 flex-row flex-wrap items-center">
        {item.prefix && <span>{item.prefix}&nbsp;</span>}
        <ExternalLink href={item.link}>{item.title}</ExternalLink>
      </div>
    </div>
  );
}

function App() {
  return (
    <main className="flex justify-center bg-backgroundPrimary w-full min-h-screen font-wix text-sm text-textPrimary">
      <div className="flex flex-col w-full mx-4 mb-2 min-[801px]:w-[700px] min-[801px]:mx-0 min-[801px]:mb-0">
        <img
          src={headerImage}
          alt="Joseph Malam"
          className="w-full mt-4 mb-2 min-[801px]:mt-8 min-[801px]:mb-8"
        />

        <Card className="p-6 border-b-0 rounded-t-xl min-[801px]:rounded-t-3xl">
          Hi, I make games, apps, and websites.
        </Card>

        <Card className="px-6 py-3 border-t-0 rounded-b-xl min-[801px]:rounded-b-3xl">
          {experience.map((item) => (
            <ExperienceItem key={item.id} item={item} />
          ))}
        </Card>
      </div>
    </main>
  );
}

export default App;
